import { ICustomFormData } from "common/records/CustomForm";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_CUSTOM_FORM = "@customForm/RECEIVE_CUSTOM_FORM";
export const RECEIVE_CUSTOM_FORMS = "@customForm/RECEIVE_CUSTOM_FORMS";
export const RESET_CUSTOM_FORM = "@customForm/RESET_CUSTOM_FORM";
export const UPDATE_CUSTOM_FORM_RJSF = "@customForm/UPDATE_CUSTOM_FORM_RJSF";

export const CustomFormActions = {
  receiveCustomForm: (customForm: Partial<ICustomFormData>) => createAction(RECEIVE_CUSTOM_FORM, customForm),
  receiveCustomForms: (customForms: Partial<ICustomFormData>[]) => createAction(RECEIVE_CUSTOM_FORMS, customForms),
  resetCustomForm: (customFormId: string | -1) => createAction(RESET_CUSTOM_FORM, { customFormId }),
  updateCustomFormRJSF: (customFormId: string | -1, formData: { [key: string]: any }) =>
    createAction(UPDATE_CUSTOM_FORM_RJSF, { customFormId, formData }),
};

export type CustomFormActions = ActionsUnion<typeof CustomFormActions>;
